// Copyright (C) 2015 Minted Inc.
// All Rights Reserved
// CTAG:COMMUNITY:CHALLENGES

(function (M, _, $, Backbone) {
  'use strict';

  M.Community = M.Community || {};
  M.Community.View = M.Community.View || {};
  M.Community.View.Challenge = M.Community.View.Challenge || {};

  /**
   * @class M.Community.View.Challenge.SquarePanel
   *
   * Description:
   *   Renders the square panel on the challenge_hub Page.
   *   Need a component sub view to fill in the middle part, otherwise
   *   the middle part will be empty
   */
  M.Community.View.Challenge.SquarePanel = Backbone.View.extend({
    options: {
      actionButtonUrl: '',
      actionButtonText: '',
      actionButtonInstrAction: ''
    },

    template: M.Template.Community.Challenge.ChallengeHubSquarePanel,
    emptyTemplate: M.Template.Community.Challenge.ChallengeHubSquarePanelEmpty,

    initialize: function() {
      this.$el = $(this.el);
    },

    render: function() {
      if (this.options.component) {
        this.$el.html(this.template(this.options));
        var $contentContainerDiv = this.$el.find('.squarePanelMainContent');
        $contentContainerDiv.append(this.options.component.render());
      }
      else {
        this.$el.html(this.emptyTemplate(this.options));
      }
      return this.$el;
    }
  });
})(M, _, $, Backbone);
